export const destroyed = {
  id: 'vbm-destroyed',
  definition: {
    unbind: function (el, binding) {
      binding.value(el)
    }
  }
}
